import React, { FC } from 'react';
import styles from '../../../styles/error.module.scss';

interface ErrorProps {}

const ErrorPage: FC<ErrorProps> = () => {
  document.title = 'Error';
  return (
    <div className={styles.notfound}>
      <div className={styles.notfound404}>
        <h1>Error</h1>
      </div>
      <h2>Unauthorized Access</h2>
    </div>
  );
};

export default ErrorPage;
